import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './styles.css';
import { closeOfferPreview } from '../../../common/actions/closeOfferPreview/closeOfferPreview';
import { closeMobileListing } from '../../../common/actions/listingModal';
import { ETestId } from '../../../common/constants/testId';
import { useEmptyListingShowTracking } from '../../../common/hooks/useEmptyListingShowTracking';
import { selectIsMapButtonVisible, selectIsModalOpen } from '../../../common/selectors/listingModal';
import { selectIsListingPending, selectVisibleListingOffers } from '../../../common/selectors/listingOffers';
import { selectQueryStringWithQMark } from '../../../common/selectors/queryString';
import { selectResultsJsonQuery } from '../../../common/selectors/results';
import { TThunkDispatch } from '../../../common/types/redux';
import { ListingMobileContent } from '../../components/ListingMobileContent';
import { OnMapButton } from '../../components/OnMapButton';
import { trackBreadcrumbsClick, trackMapButtonClick } from '../../tracking';
import { trackEmptyListingShow } from '../ListingMobile/tracking';

export const ListingMobileListingMode = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const queryString = useSelector(selectQueryStringWithQMark);
  const offers = useSelector(selectVisibleListingOffers);
  const isPending = useSelector(selectIsListingPending);
  const isListingModalOpen = useSelector(selectIsModalOpen);
  const showMapButton = useSelector(selectIsMapButtonVisible);

  const onMapButtonClick = React.useCallback(() => {
    trackMapButtonClick(jsonQuery, queryString);
    dispatch(closeOfferPreview());
    dispatch(closeMobileListing());
  }, [dispatch, jsonQuery, queryString]);

  const onBreadcrumbClick = React.useCallback(() => {
    trackBreadcrumbsClick({ offers, jsonQuery, queryString });
  }, [offers, jsonQuery, queryString]);

  const onTrackEmpty = React.useCallback(
    () => trackEmptyListingShow({ jsonQuery, queryString }),
    [jsonQuery, queryString],
  );

  const onEmptyListingShow = useEmptyListingShowTracking({
    offersLength: offers.length,
    isActive: isListingModalOpen,
    onTrack: onTrackEmpty,
  });

  return (
    <div id={ETestId.ListingBody} className={styles['root']}>
      <ListingMobileContent
        isLoading={isPending}
        offers={offers}
        isListingModalOpen={isListingModalOpen}
        onEmptyListingShow={onEmptyListingShow}
        onBreadcrumbClick={onBreadcrumbClick}
      />
      {showMapButton && <OnMapButton onClick={onMapButtonClick} />}
    </div>
  );
};

ListingMobileListingMode.displayName = 'ListingMobileListingMode';
